import { createContext, useContext, type CSSProperties, type MouseEvent, type ReactNode } from 'react';

/** Navigation côté client : un lien reste un vrai lien (clic droit, nouvel onglet) et ne recharge pas la page au clic simple. */
export type Naviguer = (chemin: string) => void;

const ContexteNavigation = createContext<Naviguer>(() => undefined);

export const FournisseurNavigation = ContexteNavigation.Provider;
export const useNaviguer = (): Naviguer => useContext(ContexteNavigation);

export function clicSimple(e: Pick<MouseEvent, 'button' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'defaultPrevented'>): boolean {
  return !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}

type ClicSouris = Pick<MouseEvent, 'button' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'defaultPrevented' | 'preventDefault'>;

/** Clic simple : on navigue sans recharger la page ; un clic modifié (nouvel onglet, etc.) reste au navigateur. */
export function gererClic(e: ClicSouris, vers: string, naviguer: Naviguer): void {
  if (!clicSimple(e)) return;
  e.preventDefault();
  naviguer(vers);
}

export interface PropsLien {
  vers: string;
  enfants: ReactNode;
  courant?: boolean;
  nav?: string;
  style?: CSSProperties;
}

export function Lien({ vers, enfants, courant = false, nav, style }: PropsLien) {
  const naviguer = useNaviguer();
  return (
    <a
      href={vers}
      {...(nav ? { 'data-nav': nav } : {})}
      {...(courant ? { 'aria-current': 'page' as const } : {})}
      style={style}
      onClick={(e) => gererClic(e, vers, naviguer)}
    >
      {enfants}
    </a>
  );
}
